import APP from 'src/main.js'
import Event from './Event.js'

class Income extends Event {
  get income_cancel(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='IncomeCancel'))||{}).child_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
    } else {
      return null
    }
  }
  get income_received(){
    return (this.income_cancel||{}).income_received
  }
  get income_trade(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='IncomeTrade'))||{}).child_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
    } else {
      return null
    }
  }
  get coract(){
    return this.constructor.employeeStore.coracts.find(cor => cor.id === this.coract_id)
  }
  get trades(){
    return this.constructor.employeeStore.events.filter((ev) => {
      return ((ev.type==='Trade')||(ev.type==='IncomeTrade'))&&
             (ev.deposit_id === this.deposit_id)&&
             (ev.issue_id===this.issue_id)&&
             (ev.sdate<this.date)
    })
  }
  get holding(){
    return this.trades.reduce((sum,tr)=> sum+(tr.amount||0),0)
  }

  get linked(){
    return this.income_trade != null || this.income_cancel != null
  }

  // Income should always be matched with an IncomeReceived
  get should_be_linked() {
    return true
  }
}
export default Income
